export default __webpack_public_path__ + "static/media/modern-design-system-dark-large.5b6a2c7d.jpg";